var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMobileSecondBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 667,
    viewBox: "0 0 375 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_225)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    fill: "#FFECE5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5_225)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 1791,
    transform: "translate(0 -344)",
    fill: "#FFECE5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 428.06,
    cy: 664.131,
    r: 745.345,
    fill: "url(#paint0_radial_5_225)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5_225",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(428.061 691.931) rotate(45) scale(614.909 1044.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F091B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9E084",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 1791,
    fill: "white",
    transform: "translate(0 -344)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMobileSecondBg);
export default __webpack_public_path__ + "static/media/course-mobile-second-bg.9c647d418ba7198ee90fbddda4e5e9fc.svg";
export { ForwardRef as ReactComponent };